import React, { useEffect, useRef } from 'react';

interface AutohideProps {
  show: boolean;
  onClose: () => void;
  seconds?: number;
}

export const Autohide: React.FC<AutohideProps> = props => {
  const { show, onClose, seconds = 5, children } = props;
  const timerIdRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    clearTimeout(timerIdRef.current);

    if (show) {
      timerIdRef.current = setTimeout(() => onClose(), seconds * 1000);
    }
    return () => clearTimeout(timerIdRef.current);
  }, [ show, onClose, seconds ]);

  if (!show) return null;

  return <>{children}</>;
};
